import { createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';
import http from 'utils/http';
import { setErrorWithoutSnack } from 'utils/helpers/fetch';

const initialState = {
  error: '',
  pending: false,
  response: {},
};

const reducers = {
  rejectPtoError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  rejectPtoPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  rejectPtoReset() {
    return initialState;
  },
  rejectPtoResetError(state) {
    return R.assoc('error', '', state);
  },
  rejectPtoSuccess(state, { payload }) {
    return R.assoc('response', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'rejectPto',
  reducers,
});

export const {
  rejectPtoPending,
  rejectPtoSuccess,
  rejectPtoError,
  rejectPtoReset,
  rejectPtoResetError,
} = actions;

// Actions
let rejectController;
export function sendRejectPto(params = {}) {
  return dispatch => {
    dispatch(rejectPtoPending(true));
    if (rejectController) rejectController.abort();
    rejectController = new AbortController();
    const { signal } = rejectController;
    return http
      .post('/product-transfer-orders/reject', params, { signal })
      .then(res => {
        dispatch(rejectPtoError(''));
        dispatch(rejectPtoSuccess(res.data));
        dispatch(rejectPtoPending(false));
      })
      .catch(error => {
        setErrorWithoutSnack(error, dispatch, rejectPtoError);
      });
  };
}

export function resetRejectPtoError() {
  return dispatch => {
    dispatch(rejectPtoResetError());
  };
}

export default reducer;
